import { MouseEventHandler } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AddIcon } from "@components/icons";
import useIsMobile from "@hooks/useIsMobile";

function AddButton({
  label,
  action,
  disabled = false,
  variant = "outline-primary",
  className = "",
}: {
  label: string;
  action: MouseEventHandler;
  disabled?: boolean;
  variant?: string;
  className?: string;
}) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <Button
      variant={variant}
      size={isMobile && !label ? "sm" : undefined}
      className={`col-auto ${isMobile && !label ? "px-2 py-1" : ""} ${className}`}
      onClick={action}
      disabled={disabled}
    >
      <AddIcon size={isMobile && !label ? "16px" : undefined} /> {label && t(label)}
    </Button>
  );
}

export default AddButton;
